// Fields to View Purchase Invoice to Paid
export default [
    {
        field: 'invoice_number',
        type: 'text',
        maxLength: 15,
        value: '',
        vuetifyProps: {
            label: 'Folio',
        },
        // rules: ['required'],
    },
    {
        field: 'pch_provider.alias_name',
        type: 'text',
        value: '',
        vuetifyProps: {
            label: 'Proveedor',
        },
        // rules: ['required'],
    },
    {
        field: 'pch_provider.rut',
        type: 'text',
        value: '',
        vuetifyProps: {
            label: 'Rut proveedor',
        },
        // rules: ['required'],
    },
    {
        field: 'pch_provider_branch_offices_id',
        type: 'text',
        value: '',
        vuetifyProps: {
            label: 'Sucursal de proveedor',
        },
        // rules: ['required'],
    },
    {
        field: 'emission_date',
        type: 'text',
        maxLength: 100,
        value: '',
        vuetifyProps: {
            label: 'Fecha emisión de factura',
        },
        // rules: ['required'],
    },
    {
        field: 'payment_date',
        type: 'text',
        value: '',
        vuetifyProps: {
            label: 'Fecha pago de factura',
        },
    },
    {
        field: 'pch_payment_condition_id',
        type: 'text',
        value: '',
        vuetifyProps: {
            label: 'Condición de pago',
        },
    },
    {
        field: 'new_subtotal',
        type: 'text',
        maxLength: 10,
        format: 'currency',
        value: '',
        vuetifyProps: {
            label: 'Subtotal',
        },
    },
    {
        field: 'iva',
        type: 'text',
        maxLength: 10,
        format: 'currency',
        value: '',
        vuetifyProps: {
            label: 'IVA',
        },
    },
    {
        field: 'total',
        type: 'text',
        maxLength: 10,
        format: 'currency',
        value: '',
        vuetifyProps: {
            label: 'Total',
        },
    },
    {
        field: 'state',
        type: 'text',
        maxLength: 25,
        value: '',
        vuetifyProps: {
            label: 'Estado',
        },
    },
    {
        field: 'is_exent',
        type: 'checkbox',
        maxLength: 255,
        value: false,
        vuetifyProps: {
            label: 'Exenta',
        },
    },
    {
        field: 'payable',
        type: 'checkbox',
        value: false,
        vuetifyProps: {
            label: 'Posible de pagar',
        },
    },
    {
        field: 'was_replaced',
        type: 'checkbox',
        value: false,
        vuetifyProps: {
            label: 'Reemplazada',
        },
    },
]
